import { render, staticRenderFns } from "./news-module.vue?vue&type=template&id=4ba98864&scoped=true&"
import script from "./news-module.vue?vue&type=script&lang=js&"
export * from "./news-module.vue?vue&type=script&lang=js&"
import style0 from "./news-module.vue?vue&type=style&index=0&id=4ba98864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba98864",
  null
  
)

export default component.exports